import React from 'react';
import BaseForm from '../../../../components/form/BaseForm';
import ImgUpload from '../../../../components/ImgUpload/ImgUpload';
import Tag from '../../../../components/tag/Tag/Tag';
import { TAG_STATUS_TEXT } from '../../../../constants/service/app/tagConstants';
import { TAG_GROUP_EDIT_URL_PATH, TAG_HISTORY_URL_PATH } from '../../../../constants/service/common/urlConstants';
import { openNewWindow, setDetailPageUrl } from '../../../../lib/common';
import { setDateFormat } from '../../../../lib/moment';

const TagHistoryInfo = (props) => {
  const { tagInfo } = props;
  const { tagName, status, connectedProductCategory, tagGroupList, relatedTagList, tagImg, createDate, updateDate } =
    tagInfo;

  return (
    <div className="tag-history-content">
      {/* 태그명*/}
      <BaseForm label="태그명" content={tagName} />

      {/* 태그 상태*/}
      <BaseForm label="태그 상태" content={TAG_STATUS_TEXT[status]} />

      {/* 상품 카테고리 연결 여부 */}
      <BaseForm label="상품 카테고리 연결 여부" content={connectedProductCategory ? '연결' : '비연결'} />

      {/* 태그 그룹*/}
      <BaseForm
        label="태그 그룹"
        content={tagGroupList.map((tagGroup) => (
          <Tag
            key={tagGroup.id}
            text={tagGroup.name}
            isAddHash={false}
            onClick={() => openNewWindow(setDetailPageUrl(TAG_GROUP_EDIT_URL_PATH, tagGroup.id))}
          />
        ))}
      />

      {/* 연관된 태그*/}
      <BaseForm
        label="연관된 태그"
        content={relatedTagList.map((tag) => (
          <Tag
            key={tag.id}
            text={tag.name}
            onClick={() => openNewWindow(setDetailPageUrl(TAG_HISTORY_URL_PATH, tag.id))}
          />
        ))}
      />

      {/* 태그 이미지*/}
      <BaseForm label="태그 이미지" content={<ImgUpload list={tagImg} modalTitle="태그 이미지" isEditable={false} />} />

      {/* 태그 등록일*/}
      <BaseForm label="태그 등록일" content={setDateFormat(createDate)} />

      {/* 태그 최종 수정일*/}
      <BaseForm label="태그 최종 수정일" content={setDateFormat(updateDate)} />
    </div>
  );
};

export default TagHistoryInfo;
